export default __webpack_public_path__ + "static/media/img_10.9660d8f5.JPG";